import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";

export default React.memo(({ isFetching, children, disabled, ...props }) => {
  return (
    <Button {...props} disabled={isFetching || disabled}>
      {
        isFetching ? <CircularProgress size={32} /> : children
      }
    </Button>
  );
});
